module.exports = __webpack_public_path__ + "static/media/article-image-2.946f6f92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/images/article-image-2.jpg
// module id = 114
// module chunks = 0